/**
 * Bas de la barre du haut collante, en pixels depuis le haut de la fenêtre.
 *
 * Sert à ancrer un défilement ou un panneau flottant SOUS la barre plutôt
 * que derrière elle. La barre elle-même n'est pas `position: sticky` (c'est son
 * conteneur `.topstack` qui l'est) : on repère donc les `<header>` plaqués en
 * haut de la fenêtre, quelle que soit leur hauteur selon le thème (48/64 px).
 *
 * @param fallback valeur retenue quand aucune barre n'est trouvée (pages sans
 *   en-tête collant, ou modale plein écran).
 */
export function getStickyHeaderBottom(fallback = 0): number {
  let bottom = fallback;
  document.querySelectorAll('header').forEach((h) => {
    const r = h.getBoundingClientRect();
    if (r.top <= 1 && r.height > 0 && r.bottom <= 120) {
      bottom = Math.max(bottom, r.bottom);
    }
  });
  return bottom;
}
